import { useQuery } from '@tv2/lib-graphql/client';
import { getAdobeVisitorValues } from '@tv2/lib-offspring/libs/adobe/adobeVisitor';
import { InfoBoxDocument } from './__generated__/InfoBox';
import CommercialInfoBoxModal from './CommercialInfoboxModal';

export default function InfoBox() {
  const adobeValues = typeof window === 'undefined' ? undefined : getAdobeVisitorValues();

  const isGoogleBot =
    typeof window === 'undefined' ? false : navigator.userAgent.toLowerCase().includes('googlebot');

  const result = useQuery({
    headers: adobeValues
      ? {
          'client-platform-adobe-visitor': JSON.stringify(adobeValues),
        }
      : undefined,
    requestPolicy: 'cache-first',
    query: InfoBoxDocument,
    pause: isGoogleBot,
  });

  const infobox = result.data?.promotionPage?.infobox;

  if (infobox?.__typename === 'CommercialInfoboxModal') {
    return <CommercialInfoBoxModal infobox={infobox} />;
  }
  if (infobox?.__typename === 'TermsAndPermissionInfobox') {
    return null; // this is resolve using the new prompts
  }

  return null;
}
